module.exports = __webpack_public_path__ + "static/media/repaymentIcon.c4a98581.svg";